import colors from '../colors';
export default {
  container: {
    backgroundColor: colors.paleGrey,
    color: colors.bluishGrey,
    background: colors.white,
    width: '576px',
    height: '344px',
    borderRadius: '4px'
  },
  backdrop: {
    position: 'fixed',
    top: '0',
    bottom: '0',
    width: '100%',
    height: '100vh',
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: '1'
  },
  closeButton: {
    position: 'absolute',
    right: '24px',
    top: '24px',
    background: 'none',
    border: '0',
    cursor: 'pointer'
  }
};